import authProvider from "../authProvider";
import Login from "../components/Login.jsx";
import { supabase } from "../utility/supabaseClient";
import { useState, useEffect } from "react";
import useSessionStore from "../stores/sessionStore";
import Spinner from "../components/Spinner.jsx";
import * as Sentry from "@sentry/react";

const Authenticated = ({ children }) => {
  const [loading, setLoading] = useState(true);

  const user = useSessionStore((state) => state.user);
  const setUser = useSessionStore((state) => state.setUser);
  //const setDevices = useSessionStore((state) => state.setDevices);

  const initialize = async () => {
    const u = await authProvider.getIdentity();// TK try/catch this and err handling
    if (!u) {
      return
    }
    setUser(u)
    Sentry.setUser({ id: u.id, email: u.email });
    setLoading(false);
  };

  useEffect(() => {
    initialize();

    const { data: listener } = supabase.auth.onAuthStateChange((_event, newSession) => {
      if (!newSession) {
        setUser(null);
      } else {
        initialize()
      }
      setLoading(false);
    });
    return () => {
      listener.subscription.unsubscribe(); // unsubscribe supabase event listener on exit
    };
  }, []);

  if (loading) {
    return (
      <Spinner />
    );
  }

  if (!user) {
    return (
      <Login />
    )
  }

  return (
    <>
      {children}
    </>
  );
}

export default Authenticated;
